import type { Ad, Label } from '../../types';

const classes = {
    badge: 'badge--positionTL',
    info: 'badge--info',
    neutral: 'badge--neutral',
    negative: 'badge--negative',
    positive: 'badge--positive',
    warning: 'badge--warning',
};

type SearchAdPrimaryLabelProps = {
    ad: Ad;
    className?: string;
    labelIds: string[];
    render: (props: LabelRenderProps) => React.ReactElement | null;
};

export type LabelRenderProps = {
    className?: string;
    classes: typeof classes;
    label?: Label;
};

export function SearchAdPrimaryLabel(props: SearchAdPrimaryLabelProps) {
    const { ad, className, labelIds, render } = props;

    function compareFn(a: Label, b: Label) {
        return labelIds.indexOf(a.id) - labelIds.indexOf(b.id);
    }
    const primaryLabel = ad.labels
        ?.filter((label) => label.type === 'PRIMARY')
        .filter((label) => labelIds.includes(label.id))
        .sort(compareFn)
        .shift();

    return render({ className, classes, label: primaryLabel });
}
